module.exports = __webpack_public_path__ + "img/tsos.dd5b791d.svg";